import React from 'react';

const InfoArteFinalText = ({ children, ...props }) => {
  return <p {...props}>{children}</p>;
};

export default InfoArteFinalText;
